import React, { useEffect, useRef } from "react";

function ToastSuccess({ show, message }) {
  const toastRef = useRef(null);

  useEffect(() => {
    if (show && toastRef.current) {
      const toastInstance = new window.bootstrap.Toast(toastRef.current, {
        autohide: true,
      });
      toastInstance.show();
    }
  }, [show]);

  return (
    <div
      ref={toastRef}
      className="toast border-0 shadow-sm rounded-2"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      data-bs-delay="5000"
    >
      <div
        className="d-flex justify-content-center align-items-center gap-3 px-3 py-2 rounded-2"
        style={{ backgroundColor: "#5aa25f" }}
      >
        {/* Icon */}
        <div
          className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
          style={{
            width: "32px",
            height: "32px",
            backgroundColor: "rgba(255,255,255,0.2)",
          }}
        >
          <span className="text-white fw-bold">✓</span>
        </div>

        <p className="toast-body p-0 text-white small m-0 fw-bold">{message}</p>

        <button
          type="button"
          className="btn-close btn-close-white ms-auto"
          data-bs-dismiss="toast"
          aria-label="Close"
        />
      </div>
    </div>
  );
}

export default ToastSuccess;
